
/**
 * Firestore merchants_v2 컬렉션의 MerchantV2 문서 인터페이스
 */
export interface MerchantV2 {
  category_code: string;
  merchant_id: string;
  merchant_image_url: string;
  merchant_name: string;
  merchant_url: string;
  recommended: boolean;
  allowedUsers: string[] | null; // recommended가 false일 때만 사용
  allowedEnterprises: string[] | null; // recommended가 false일 때만 사용
}

/**
 * MerchantV2 컬렉션 경로 상수
 */
export const MERCHANT_V2_COLLECTION = process.env.REACT_APP_MERCHANTS_V2_COLLECTION as string;
